<div class="field-selector">
  <span class="field-selector__title">
    {{ 'TRANS__COPY_FIELDS__FIELD_SELECTOR_TITLE' | translate }}
  </span>
  <div class="field-selector__actions">
    <button mat-button color="primary" (click)="selectAll.emit()">
      {{ 'TRANS__COPY_FIELDS__SELECT_ALL_SECTIONS' | translate }}
    </button>
    <button mat-button color="primary" (click)="clearAll.emit()">
      {{ 'TRANS__COPY_FIELDS__CLEAR_ALL_SECTIONS' | translate }}
    </button>
  </div>
</div>
